// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37cL5","content":"styles_content__u1HaP"};